import { ReactComponent as CursorIcon } from 'Images/cursor.svg';

import { PLACEHOLDER } from './placeholders';
import buildHeaderLines from './headers';
import {
  AUTH_TOKEN,
  AUTH_USER_PASSWORD,
  BLOCK_FILE,
  BLOCK_NOTE,
  BLOCK_PATHS,
  CLIENT_STATUS_SUPPORTED
} from './constants';

const buildConfig = (authMethod) => `{
  "mcpServers": {
    "faraday": {
      "url": "${PLACEHOLDER.serverUrl}",
      "headers": {
${buildHeaderLines(authMethod, '        ', ': ')}
      }
    }
  }
}`;

const cursor = {
  id: 'cursor',
  label: 'Cursor',
  icon: CursorIcon,
  status: CLIENT_STATUS_SUPPORTED,
  authMethods: [AUTH_TOKEN, AUTH_USER_PASSWORD],
  summaryId: 'mcp.client.cursor.summary',
  buildSections: ({ authMethod }) => [
    {
      id: 'config',
      titleId: 'mcp.client.cursor.config.title',
      blocks: [
        {
          id: 'config-file',
          type: BLOCK_FILE,
          captionId: 'mcp.client.cursor.config.caption',
          snippet: buildConfig(authMethod)
        }
      ]
    },
    {
      id: 'locations',
      titleId: 'mcp.client.cursor.locations.title',
      blocks: [
        {
          id: 'paths',
          type: BLOCK_PATHS,
          items: [
            { id: 'project', labelId: 'mcp.client.cursor.locations.project', value: '.cursor/mcp.json' },
            { id: 'global', labelId: 'mcp.client.cursor.locations.global', value: '~/.cursor/mcp.json' }
          ]
        },
        {
          id: 'verify',
          type: BLOCK_NOTE,
          textId: 'mcp.client.cursor.locations.verify'
        }
      ]
    }
  ]
};

export default cursor;
